import React from "react";
import classNames from "classnames";

function SettingsList(props) {
	let listItemClasses = classNames({
		"list-item": true,
		"active-item": props.location.pathname === props.listItem.path,
		disabled: props.listItem.disabled === true,
	});

	return (
		<div className={listItemClasses}>
			<p>{props.listItem.title}</p>
		</div>
	);
}

export default SettingsList;
